<template>
  <div
    v-if="showPanel"
    class="col-lg-6 vg-confirmation-col vg-confirmation-col--gifts"
  >
    <section
      class="order-summary vg-confirmation-panel vg-confirmation-panel--gifts vg-confirmation-gifts"
      :aria-label="panelAriaLabel"
    >
      <template
        v-if="giftEntries.length > 0 && activeConfirmationSettings.showGifts"
      >
        <header class="order-summary__header">
          <span class="order-summary__header-icon" aria-hidden="true">
            <svg viewBox="0 0 512 512" aria-hidden="true" focusable="false">
              <path
                fill="currentColor"
                d="M190.5 68.8L225.3 128H224 152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zM233.4 47.5C226.6 20.3 201.9 0 173.8 0H152C86.3 0 32 54.3 32 120c0 5.5 .4 10.9 1.1 16.2C14 147.3 0 170.6 0 197.3V320 416c0 35.3 28.7 64 64 64H192V320 197.3c0-14.7 11.9-26.7 26.7-26.7h10.7c-8.2-19.6-8.2-42.1 0-61.7H233.4zM288 512H448c35.3 0 64-28.7 64-64V320 197.3c0-26.7-14-50-35.1-61.1c.7-5.3 1.1-10.7 1.1-16.2c0-65.7-54.3-120-120-120H338.2c-28.1 0-52.8 20.3-59.6 47.5H288c8.2 19.6 8.2 42.1 0 61.7h10.7c14.7 0 26.7 11.9 26.7 26.7V320 512zM286.7 128L321.5 68.8C329 55.9 342.9 48 357.8 48H360c22.1 0 40 17.9 40 40s-17.9 40-40 40H288h-1.3z"
              />
            </svg>
          </span>
          <span class="order-summary__header-label">{{ giftsTitle }}</span>
        </header>
        <p v-if="giftsLead" class="vg-confirmation-gifts__lead">
          {{ giftsLead }}
        </p>
        <ul class="vg-confirmation-gifts__list">
          <li
            v-for="(entry, index) in giftEntries"
            :key="`${entry.url || entry.name}-${index}`"
            class="vg-confirmation-gifts__item"
          >
            <span class="vg-confirmation-gifts__icon" aria-hidden="true">
              <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                <path
                  fill="currentColor"
                  fill-rule="evenodd"
                  d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
                />
                <path
                  fill="currentColor"
                  fill-rule="evenodd"
                  d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                />
              </svg>
            </span>
            <div class="vg-confirmation-gifts__body">
              <span class="vg-confirmation-gifts__name">{{ entry.name }}</span>
              <a
                v-if="entry.url"
                :href="entry.url"
                class="vg-confirmation-gifts__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ $t("labels.programAccessAction") }}
                <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                  <path
                    fill="currentColor"
                    fill-rule="evenodd"
                    d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
                  />
                  <path
                    fill="currentColor"
                    fill-rule="evenodd"
                    d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                  />
                </svg>
              </a>
            </div>
          </li>
        </ul>
      </template>

      <template
        v-if="
          activeConfirmationSettings.showLinkRedirects &&
          showProgramAccessSection
        "
      >
        <header
          class="order-summary__header"
          :class="{
            'vg-confirmation-gifts__access-header':
              giftEntries.length > 0 && activeConfirmationSettings.showGifts,
          }"
        >
          <span class="order-summary__header-icon" aria-hidden="true">
            <svg viewBox="0 0 512 512" aria-hidden="true" focusable="false">
              <path
                fill="currentColor"
                d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l82.7 0L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3l0 82.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192c0-17.7-14.3-32-32-32L320 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 80c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z"
              />
            </svg>
          </span>
          <span class="order-summary__header-label">{{ accessTitle }}</span>
        </header>
        <p v-if="programAccessLead" class="vg-confirmation-gifts__lead">
          {{ programAccessLead }}
        </p>
        <div
          v-if="subscriberKeyFetchState === 'loading'"
          class="vg-confirmation-gifts__loading"
          role="status"
          aria-live="polite"
        >
          <span
            class="spinner-border spinner-border-sm"
            aria-hidden="true"
          ></span>
          <span>{{ $t("labels.programAccessLoading") }}</span>
        </div>
        <ul
          v-else-if="programLinks.length > 0"
          class="vg-confirmation-gifts__list"
        >
          <li
            v-for="(link, index) in programLinks"
            :key="`${link.url}-${index}`"
            class="vg-confirmation-gifts__item"
          >
            <span class="vg-confirmation-gifts__icon" aria-hidden="true">
              <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                <path
                  fill="currentColor"
                  fill-rule="evenodd"
                  d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
                />
                <path
                  fill="currentColor"
                  fill-rule="evenodd"
                  d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                />
              </svg>
            </span>
            <div class="vg-confirmation-gifts__body">
              <span class="vg-confirmation-gifts__name">{{
                link.label || $t("labels.programAccessLink")
              }}</span>
              <a
                :href="link.url"
                class="vg-confirmation-gifts__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ $t("labels.programAccessAction") }}
                <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                  <path
                    fill="currentColor"
                    fill-rule="evenodd"
                    d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
                  />
                  <path
                    fill="currentColor"
                    fill-rule="evenodd"
                    d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                  />
                </svg>
              </a>
            </div>
          </li>
        </ul>
      </template>
    </section>
  </div>
</template>

<script>
import { useOrderHistoryStore } from "@/store/orderHistory";
import { useConfirmationContextStore } from "@/store/confirmationContext";
import {
  linkRedirectsNeedSubscriberKey,
  resolveProgramLinks,
} from "@/services/programLinks";
import {
  fetchSubscriberKey,
  getBillingEmailFromHistory,
  needsSubscriberKeyFetch,
} from "@/services/subscriberKey";
import { shouldHideConfirmationGiftsForCancelPolicy } from "@/services/confirmationOrder";
import {
  normalizeConfirmationDisplayMode,
  resolveConfirmationGiftEntries,
} from "@/services/confirmationGifts";

export default {
  name: "CheckoutConfirmationGifts",
  data() {
    return {
      cart: null,
      order: null,
      orderStep: 0,
      programLinks: [],
      subscriberKeyFetchState: "idle",
      fetchRequestId: 0,
      onVueAppMounted: null,
    };
  },
  computed: {
    historyLastUpdate() {
      return useOrderHistoryStore().lastUpdate;
    },
    confirmationContextResolved() {
      return useConfirmationContextStore().resolved;
    },
    activeConfirmationSettings() {
      return useConfirmationContextStore().activeSettings;
    },
    confirmationLinkRedirectsKey() {
      const settings = this.activeConfirmationSettings;
      return `${settings.linkRedirectsDisplayMode}|${settings.showLinkRedirects}`;
    },
    shouldHideForCancelPolicy() {
      return shouldHideConfirmationGiftsForCancelPolicy(
        this.order,
        this.orderStep,
      );
    },
    linkRedirectsNeedSubscriberKey() {
      return linkRedirectsNeedSubscriberKey();
    },
    giftsTitle() {
      return this.giftEntries.length > 1
        ? this.$t("labels.confirmationGifts")
        : this.$t("labels.confirmationGift");
    },
    accessTitle() {
      const redirects = window.productDetails?.linkRedirects || [];
      return redirects.length > 1
        ? this.$t("labels.yourAccess")
        : this.$t("labels.yourAccessSingular");
    },
    giftsLead() {
      return this.giftEntries.length > 1
        ? this.$t("labels.confirmationGiftsLead")
        : this.$t("labels.confirmationGiftLead");
    },
    programAccessLead() {
      const redirects = window.productDetails?.linkRedirects || [];
      return redirects.length > 1
        ? this.$t("labels.programAccessLead")
        : this.$t("labels.programAccessLeadSingular");
    },
    showProgramAccessSection() {
      if (
        this.subscriberKeyFetchState === "loading" &&
        this.linkRedirectsNeedSubscriberKey
      ) {
        return true;
      }

      if (
        this.subscriberKeyFetchState === "failed" &&
        this.linkRedirectsNeedSubscriberKey
      ) {
        return false;
      }

      return this.programLinks.length > 0;
    },
    showPanel() {
      if (this.shouldHideForCancelPolicy) {
        return false;
      }

      const showGifts =
        this.activeConfirmationSettings.showGifts &&
        this.giftEntries.length > 0;
      const showRedirects =
        this.activeConfirmationSettings.showLinkRedirects &&
        this.showProgramAccessSection;
      return showGifts || showRedirects;
    },
    panelAriaLabel() {
      const showGifts =
        this.activeConfirmationSettings.showGifts &&
        this.giftEntries.length > 0;
      const showRedirects =
        this.activeConfirmationSettings.showLinkRedirects &&
        this.showProgramAccessSection;

      if (showGifts && showRedirects) {
        return `${this.giftsTitle} / ${this.accessTitle}`;
      }
      if (showRedirects) {
        return this.accessTitle;
      }
      return this.giftsTitle;
    },
    giftEntries() {
      const history = useOrderHistoryStore().activeOrderHistory || [];
      const mode = normalizeConfirmationDisplayMode(
        this.activeConfirmationSettings.giftsDisplayMode,
        this.activeConfirmationSettings.showGifts,
        "last",
      );
      return resolveConfirmationGiftEntries(history, mode);
    },
  },
  watch: {
    historyLastUpdate: {
      handler() {
        this.syncHistoryItem();
      },
    },
    confirmationContextResolved() {
      this.syncHistoryItem();
    },
    confirmationLinkRedirectsKey() {
      this.syncHistoryItem();
    },
  },
  mounted() {
    this.onVueAppMounted = () => {
      this.syncHistoryItem();
    };
    document.addEventListener("vue-app-mounted", this.onVueAppMounted);
    useOrderHistoryStore().ensureCurrentOrderScope();
    this.syncHistoryItem();
  },
  beforeUnmount() {
    document.removeEventListener("vue-app-mounted", this.onVueAppMounted);
  },
  methods: {
    async syncHistoryItem() {
      const store = useOrderHistoryStore();
      const historyItem = store.activeLastOrderHistoryItem;
      this.cart = historyItem?.cart || null;
      this.order = historyItem?.order || null;
      this.orderStep = historyItem?.step || 0;

      const history = store.activeOrderHistory || [];
      const requestId = ++this.fetchRequestId;

      if (needsSubscriberKeyFetch(history)) {
        this.subscriberKeyFetchState = "loading";
        this.programLinks = [];

        try {
          const email = getBillingEmailFromHistory(history);
          const subscriberKey = await fetchSubscriberKey(email);
          if (requestId !== this.fetchRequestId) {
            return;
          }
          store.setBillingSubscriberKey(subscriberKey);
          this.subscriberKeyFetchState = "ready";
        } catch (error) {
          if (requestId !== this.fetchRequestId) {
            return;
          }
          console.error(error);
          this.subscriberKeyFetchState = "failed";
          this.programLinks = [];
          return;
        }
      } else {
        this.subscriberKeyFetchState = "idle";
      }

      if (requestId !== this.fetchRequestId) {
        return;
      }

      this.programLinks = resolveProgramLinks({
        displayMode: normalizeConfirmationDisplayMode(
          this.activeConfirmationSettings.linkRedirectsDisplayMode,
          this.activeConfirmationSettings.showLinkRedirects,
          "all",
        ),
      });
    },
  },
};
</script>

<style scoped>
.vg-confirmation-gifts__loading {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #495057;
  font-size: 0.95rem;
}
</style>
